import React, { useRef } from 'react';
var VeltNotificationsPanelSettings = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings", { ref: ref }, children));
};
export default VeltNotificationsPanelSettings;
